import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { DialogService } from '../services/dialog.service';
import { ScannerQRCodeConfig, ScannerQRCodeResult, NgxScannerQrcodeService, ScannerQRCodeSelectedFiles, NgxScannerQrcodeComponent } from 'ngx-scanner-qrcode';
import { Route, Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-device-scanner',
  templateUrl: './device-scanner.component.html',
  styleUrls: ['./device-scanner.component.css']
})
export class DeviceScannerComponent implements AfterViewInit {

  public config: ScannerQRCodeConfig = {
    constraints: {
      video: {
        width: 400,
        height: 400,
      },
    },
   
  };

  qrCodeResult: ScannerQRCodeSelectedFiles[] = [];
  qrCodeResultString:string="";
  isActive = false;

  @ViewChild('action') action!: NgxScannerQrcodeComponent;
  

  constructor(private dialogService: DialogService,
    public dialogRef: MatDialogRef<DeviceScannerComponent>,) {

   }

  ngAfterViewInit(): void {
    this.handle(this.action, 'start');
  }

  public onEvent(e: ScannerQRCodeResult[], action?: any): void {

    this.qrCodeResultString=e[0].value
  
    let serialNumber;
    // Check if the string contains "http" to determine if it's a URL
    try {
      if(this.qrCodeResultString.startsWith("http") && this.qrCodeResultString.includes("/qrDevice")) {
        const fragment = new URL(this.qrCodeResultString).hash; // "#/qrDevice?serial_number=12345-12345-12345"
        const queryPart = fragment.split('?')[1]; // "serial_number=12345-12345-12345"
        
        const params = new URLSearchParams(queryPart);
        serialNumber = params.get('serial_number');
      } else {
        serialNumber = this.qrCodeResultString;
      }
    } catch (error) {
      this.showError()
    }

    if(serialNumber) {
      this.dialogRef.close({serial_number: serialNumber});
    } else {
      this.showError();
    }

  }

  public handle(action: any, fn: string): void {
    const playDeviceFacingBack = (devices: any[]) => {
      // front camera or back camera check here!
      const device = devices.find(f => (/back|rear|environment/gi.test(f.label))); // Default Back Facing Camera
      action.playDevice(device ? device.deviceId : devices[0].deviceId);
    }

    if (fn === 'start') {
      this.isActive=true;
      action[fn](playDeviceFacingBack).subscribe((r: any) => console.log(fn, r), alert);
    } else {
      this.isActive=false;
      action[fn]().subscribe((r: any) => console.log(fn, r), alert);
    }
  }

  showError() {
    this.handle(this.action, 'stop');
    this.dialogService.confirmDialog({
      title: 'Usuario',
      message: "Código QR no válido",
      message2: "Pruebe con otro código QR",
      confirmText: 'OK',
      cancelText: '',
      showConfirmBox: false,
      dialogType: "E",
    }).subscribe((yes) => {
      this.handle(this.action, 'start');
    });
  }


}